// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container {
  height: calc(100% - 0px);
  margin: 0rem !important;
  width: 100%;
  display: flex;
  flex-flow: column wrap;
}

.navigation-container {
  background-color: var(--backgroundColor);
  margin: 0rem !important;
  padding: 0rem 1rem 0rem 1rem;
  flex-flow: column wrap;
  flex: 1 1 100%;
}

.navigation-container::before {
  content: "";
  position: absolute;
  border: solid 1px #DFDFDF;
  background-color: white;
  border-radius: 0 10px 10px 10px;
}

.navigation-container.opened {
  width: 300px;
}

.navigation-container.opened::before {
  inset: 77px 12px 8px 300px;
}

.navigation-container.closed {
  width: 30px;
}

.navigation-container.closed::before {
  inset: 77px 12px 8px 30px;
}

.module-container {
  /* padding-top: 15px !important; */
  margin: 0rem !important;
  flex-flow: column;
  flex: 1 1 100%;
}

.module-container.navigation-container.opened {
  width: calc(100% - 300px);
}

.module-container.navigation-container.closed {
  width: calc(100% - 30px);
}

.header-container {
  height: 65px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.header-content {
  padding: 0 0 0 0 !important;
}

.header-content>.column {
  align-items: center;
  display: flex !important;
}

.header-content>.column:last-child {
  justify-content: flex-end;
}

.header-content .ui.compact.menu {
  border: none;
}

.hide {
  display: none !important;
}

.show {
  /*position: absolute !important;*/
  /*top: -32px;*/
  /*right: -20px;*/
  max-height: 100vh;
  height: auto;
}

.navigation-content {
  height: calc(100% - 16px);
  padding-bottom: 0 !important;
  padding-top: 0 !important;
  padding-right: 0 !important;
}

.navigation-content .segment {
  border-radius: 0;
  margin-left: -15px;
}

.navigation-content .ui.segment {
  border-radius: 0;
  border: 0;
}

.navigation {
  background-color: grey;
  color: #fff;
  position: absolute;
  right: -10px;
  top: 35px;
  cursor: pointer;
  height: auto !important;
  padding: 6px 0 !important;
  font-size: 20px !important;
}

.code-cell .e-control.e-btn,
.right.item .e-control.e-btn {
  padding: 3px 0px 0px 0px !important;
  border-radius: 4px;
  margin: 0px 3px 0px 3px;
  height: 21px;
  width: 21px;
}

.code-cell .e-control.e-btn .e-icons,
.right.item .e-control.e-btn .e-icons {
  font-size: 13px !important;
}

.code-cell .e-control.e-btn.e-disabled,
.code-cell .e-control.e-btn.e-disabled *,
.right.item .e-control.e-btn.e-disabled,
.right.item .e-control.e-btn.e-disabled * {
  cursor: default !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/module/styles.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;EACvB,4BAA4B;EAC5B,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;EAEE,mCAAmC;EACnC,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;;;EAIE,0BAA0B;AAC5B","sourcesContent":[".main-container {\n  height: calc(100% - 0px);\n  margin: 0rem !important;\n  width: 100%;\n  display: flex;\n  flex-flow: column wrap;\n}\n\n.navigation-container {\n  background-color: var(--backgroundColor);\n  margin: 0rem !important;\n  padding: 0rem 1rem 0rem 1rem;\n  flex-flow: column wrap;\n  flex: 1 1 100%;\n}\n\n.navigation-container::before {\n  content: \"\";\n  position: absolute;\n  border: solid 1px #DFDFDF;\n  background-color: white;\n  border-radius: 0 10px 10px 10px;\n}\n\n.navigation-container.opened {\n  width: 300px;\n}\n\n.navigation-container.opened::before {\n  inset: 77px 12px 8px 300px;\n}\n\n.navigation-container.closed {\n  width: 30px;\n}\n\n.navigation-container.closed::before {\n  inset: 77px 12px 8px 30px;\n}\n\n.module-container {\n  /* padding-top: 15px !important; */\n  margin: 0rem !important;\n  flex-flow: column;\n  flex: 1 1 100%;\n}\n\n.module-container.navigation-container.opened {\n  width: calc(100% - 300px);\n}\n\n.module-container.navigation-container.closed {\n  width: calc(100% - 30px);\n}\n\n.header-container {\n  height: 65px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n}\n\n.header-content {\n  padding: 0 0 0 0 !important;\n}\n\n.header-content>.column {\n  align-items: center;\n  display: flex !important;\n}\n\n.header-content>.column:last-child {\n  justify-content: flex-end;\n}\n\n.header-content .ui.compact.menu {\n  border: none;\n}\n\n.hide {\n  display: none !important;\n}\n\n.show {\n  /*position: absolute !important;*/\n  /*top: -32px;*/\n  /*right: -20px;*/\n  max-height: 100vh;\n  height: auto;\n}\n\n.navigation-content {\n  height: calc(100% - 16px);\n  padding-bottom: 0 !important;\n  padding-top: 0 !important;\n  padding-right: 0 !important;\n}\n\n.navigation-content .segment {\n  border-radius: 0;\n  margin-left: -15px;\n}\n\n.navigation-content .ui.segment {\n  border-radius: 0;\n  border: 0;\n}\n\n.navigation {\n  background-color: grey;\n  color: #fff;\n  position: absolute;\n  right: -10px;\n  top: 35px;\n  cursor: pointer;\n  height: auto !important;\n  padding: 6px 0 !important;\n  font-size: 20px !important;\n}\n\n.code-cell .e-control.e-btn,\n.right.item .e-control.e-btn {\n  padding: 3px 0px 0px 0px !important;\n  border-radius: 4px;\n  margin: 0px 3px 0px 3px;\n  height: 21px;\n  width: 21px;\n}\n\n.code-cell .e-control.e-btn .e-icons,\n.right.item .e-control.e-btn .e-icons {\n  font-size: 13px !important;\n}\n\n.code-cell .e-control.e-btn.e-disabled,\n.code-cell .e-control.e-btn.e-disabled *,\n.right.item .e-control.e-btn.e-disabled,\n.right.item .e-control.e-btn.e-disabled * {\n  cursor: default !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
